import { render } from "./ProgressBar.vue?vue&type=template&id=12811027&scoped=true&ts=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=12811027&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12811027"]])

export default __exports__